module.exports = __webpack_public_path__ + "static/img/function_button.7818e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/function_button.png
// module id = JYIR
// module chunks = 1